(function () {
	var App = angular.module('pphhApp');
	App.controller('admDir3Controller', ['$scope', '$mdDialog', "$interval", "$timeout", "CommonCatalogService", "admDir3Service", AdmDir3Controller]);
	
	function AdmDir3Controller($scope, $mdDialog, $interval, $timeout, commonCatalogService, admDir3Service) {
		$scope.isLoading = false;

		$scope.filterResults = [];
		$scope.init = function () {
			$interval(doFilter, 60000);
		};

		$scope.doFilter = doFilter;
		$scope.propagar = propagar;
		$scope.syncRunning = syncRunning; 
		
		function doFilter(tableState, ctrl) {
			$scope.isLoading = true;

			admDir3Service.getConnections( $scope.fechaDesde, $scope.fechaHasta)
				.then (
					function(response) {
						$scope.filterResults = response.data;
						$scope.isLoading = false;
					},
					function(reponse) {
						showGenericError("Error filter.");
						$scope.isLoading = false;
					}
				);
		}

		function propagar() {
			$scope.isLoading = true;
			admDir3Service.propagarCambios().then (
					function(response) {
						$timeout(function () {
							$scope.isLoading = false;
							doFilter();
						}, 5000);
					},
					function(reponse) {
						showGenericError("Error registrando petición de sincronización.");
						$scope.isLoading = false;
					}
			);
		}
		
		function syncRunning() {
			var running = false;
			angular.forEach($scope.filterResults, function (row) {
				if(row.fechaFin == null) {
					running = true;
				}
			});
			
			return running;
		}

		function showGenericError(message) {
			$mdDialog.show(
					$mdDialog.alert({
						title: UIMessages.dialog.confirm.title,
						textContent: "Error get",
						ok: UIMessages.dialog.confirm.cerrar,
						multiple: true
					}));
		}
	}
})();
